type JournalIntegrationConfig = {
  commonFitProps: {
    siteId: string;
    commonIesClientId: string;
    fitjsUrl: string;
  };
  workflowSettings: Record<string, unknown>;
};

export function prepareFitConfig(toolConfig: JournalIntegrationConfig) {
  const {
    commonFitProps: { siteId, commonIesClientId },
    ...restConfig
  } = toolConfig;

  return {
    FITConfigs: {
      siteId,
      commonIesClientId,
      integrations: {
        JOURNALS: {
          ...restConfig,
        },
      },
    },
  };
}
